import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubbleWideSparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBubbleWideSparkle"><Path d="M12.5 3.50001L2.5 3.5V18.5L9.0155 18.5L11.9979 21L15.0155 18.5H21.5V12.5" stroke="currentColor" strokeLinecap="square"/><Path d="M19.4 2H18.6L17.6 4.6L15 5.6V6.4L17.6 7.4L18.6 10H19.4L20.4 7.4L23 6.4V5.6L20.4 4.6L19.4 2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBubbleWideSparkle;
